import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Labor',
  icon: 'mdi-timer-sand',
  path: '/reports/mcd/controlsLabor/',
  children: [
    {
      path: '/reports/mcd/controlsLabor/allHours',
      name: 'All Hours',
      meta: { id: 'reports-allHours' },
      component: () => import('./allhours/allHours.vue'),
      ...addPermissionsToRoute(['allHours']),
      tags: ['All Hours Pre and Post'],
    },
    {
      path: '/reports/mcd/controlsLabor/laborAnalysisSummary',
      name: 'Schedule Analysis Summary',
      meta: { id: 'reports-scheduleAnalysisSummary' },
      component: () => import('./laborAnalysisSummary/LaborAnalysisSummaryReport.vue'),
      ...addPermissionsToRoute(['laborStatistics']),
    },
    {
      path: '/reports/mcd/controlsLabor/laborStatistics',
      name: 'Labor Statistics',
      meta: { id: 'reports-laborStatistics' },
      component: () => import('./labor-statistics.vue'),
      ...addPermissionsToRoute(['laborStatistics']),
    },
    {
      path: '/reports/mcd/controlsLabor/laborSchedules',
      name: 'Labor Schedules',
      component: () => import('./laborSchedules/laborSchedules.vue'),
      meta: { id: 'reports-laborSchedules' },
      ...addPermissionsToRoute(['laborSchedules']),
    },
    {
      path: '/reports/mcd/controlsLabor/laborAnalysis',
      name: 'Labor Analysis',
      component: () => import('./labor-analysis.vue'),
      ...addPermissionsToRoute(['laborStatistics']),
      meta: { id: 'reports-laborAnalysis' },
      tags: ['Actual Labor Analysis'],
    },
    {
      path: '/reports/mcd/controlsLabor/scheduleVariance',
      name: 'Schedule Variance',
      meta: { id: 'reports-scheduleVariance' },
      component: () => import('./scheduleVariance.vue'),
      ...addPermissionsToRoute(['laborStatistics']),
    },
    {
      path: '/reports/mcd/controlsLabor/vlhOverUnder',
      name: 'VLH Over/Under',
      meta: { id: 'reports-vlhOverUnder' },
      component: () => import('./vlhOverUnder.vue'),
      ...addPermissionsToRoute(['laborSchedules']),
      tags: ['Variable Labor Hours'],
    },
  ]
};

export default routes;
